import jsPDF from 'jspdf';
import { format } from 'date-fns';
import { Button } from 'antd';
import type { AppOffer } from 'hooks/useAppOffers';
import { DownloadOutlined } from '@ant-design/icons';
import { getLegacyOfferContent } from '../Agreements/Offers/legacyOfferContent';
export {
  getCurrencyFormat,
  getCurrencyLiterPriceFormat,
} from '../Agreements/Offers/legacyOfferContent';

export default function OfferPDF({ appOffer }: { appOffer: AppOffer }) {
  return <Button icon={<DownloadOutlined />} onClick={() => getPDF(appOffer)} />;
}

function getPDF(appOffer: AppOffer) {
  const refId = appOffer.refId;
  const timestamp = format(appOffer.updateTime, 'dd-MM-yyyy');
  const offerReceiverCompany = appOffer.title;
  const doc = new jsPDF();

  const margin = 20;
  const lineHeight = 5;
  const maxWidth = doc.internal.pageSize.width - margin * 2;
  const pageHeight = doc.internal.pageSize.height;
  const bottomMargin = 20;
  let y = margin + 20;
  doc.addImage(require('../../assets/logos/aks_logo.png'), 'PNG', margin, 10, 40, 10);
  doc.setFontSize(10);
  doc.setFont('helvetica');
  doc.text(`Ref: ${refId}`, maxWidth - 20, 15);
  doc.text(`${timestamp}`, maxWidth + 3, 20);
  function addHeader(text: string, fontSize = 16) {
    checkPageOverflow(lineHeight + 5);
    doc.setFontSize(fontSize);
    doc.setFont('helvetica', 'bold');
    doc.text(text, margin, y);
    y += lineHeight + 5;
  }
  function addSignature() {
    y += 20;
    checkPageOverflow(lineHeight + 5);
    doc.line(margin, y, maxWidth / 2, y);
    doc.text('Navn:', margin, y + 5);
    doc.text('Dato:', margin, y + 10);
    doc.line(margin * 2 + maxWidth / 2, y, maxWidth + margin, y);
    doc.text('Navn:', margin * 2 + maxWidth / 2, y + 5);
    doc.text('Dato:', margin * 2 + maxWidth / 2, y + 10);
    y += lineHeight + 5;
  }

  function addParagraph(text: string) {
    const lines = doc
      .setFont('helvetica')
      .setFontSize(12)
      .splitTextToSize(text, maxWidth - margin);

    checkPageOverflow(lines.length * lineHeight + 5);
    doc.setFontSize(12);
    doc.setFont('helvetica', 'normal');
    doc.text(lines, margin, y);
    y += lines.length * lineHeight + 5;
  }

  function addList(items: string[]) {
    items.forEach((item) => {
      const lines = doc
        .setFont('helvetica')
        .setFontSize(12)
        .splitTextToSize(item, maxWidth - margin);
      checkPageOverflow(lines.length * lineHeight);
      doc.setFontSize(12);
      doc.setFont('helvetica', 'normal');
      doc.text('•', margin, y);
      doc.text(lines, margin + 10, y);
      y += lines.length * lineHeight;
    });
    y += 5;
  }

  function checkPageOverflow(contentHeight: number) {
    if (y + contentHeight > pageHeight - bottomMargin) {
      doc.addPage();
      y = margin;
    }
  }

  for (const part of getLegacyOfferContent(appOffer)) {
    if (part.type === 'heading') addHeader(part.text, part.fontSize);
    else if (part.type === 'paragraph') addParagraph(part.text);
    else addList(part.items);
  }
  addSignature();
  doc.save(
    `Tilbud-${offerReceiverCompany.split(' ').join('-')}-${format(new Date(), 'yyyy-MM-dd')}.pdf`
  );
}
